import translations from './translations'

translations.add('pt', {
    selectBank: 'escolha o seu banco'
})
